"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var dropdownThemefication = function dropdownThemefication(button, children, parent) {
  var theme = {
    top: "\n      bottom: ".concat(button.height, "px;\n      transform: translate(0px,0px);\n    "),
    right: "\n      top: 0;\n      transform: translate(".concat(button.width, "px,0px);\n    "),
    left: "\n      top: 0;\n      transform: translate(-".concat(children.width, "px,0px);\n    "),
    bottom: "\n      top: ".concat(button.height, "px;\n      transform: translate(0px,0px);\n    ")
  };
  var themeWithParent = {
    top: "\n        top: 0px;\n        transform: translate(".concat(button.x, "px,\n          ").concat(button.y + button.pageYOffset - children.height, "px);\n      "),
    right: "\n        top: 0;\n        transform: translate(".concat(button.x + button.width, "px,\n          ").concat(button.y + button.pageYOffset, "px);\n      "),
    left: "\n        top: 0;\n        transform: translate(".concat(button.x - children.width, "px,\n          ").concat(button.y + button.pageYOffset, "px);\n      "),
    bottom: "\n        top: 0px;\n        transform: translate(".concat(button.x, "px,").concat(button.height + button.y + button.pageYOffset, "px);\n      ")
  };
  return parent ? themeWithParent : theme;
};

var _default = dropdownThemefication;
exports.default = _default;